class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.autoCloseTab();
        FacetFiltersForm.priceFilter();
       // FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.autoCloseTab();
    FacetFiltersForm.priceFilter();
    //FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
      var gridWrapper = document.querySelector('#product-grid');
      const _cardAtcBtn = () => {
        gridWrapper.querySelectorAll('.card-wrapper-box').forEach( (quickCartContainer) => {
          if (quickCartContainer.querySelector('.ethnc-qatc-btn-container')) {
            quickCartContainer.querySelector('.ethnc-qatc-btn-container').addEventListener('click', (evt) => {
              const mediaContainer = quickCartContainer.querySelector('.ethnc-form-media');
              quickCartContainer.querySelector('.bt-qatc-container').addEventListener('click', (evt) => {
                if (evt.target.classList.contains('bt-qatc-container')) {
                  quickCartContainer.querySelector('.bt-qatc-container').classList.remove('is-visible');
                  quickCartContainer.querySelector('.bt-qatc-form-container').classList.remove ('is-visible');
                  document.body.classList.remove('overflow-hidden');
                  mediaContainer.innerHTML = null;
                }
              });
    
              const atcForm = quickCartContainer.querySelector('.bt-qatc-form');
              if (quickCartContainer.querySelector('.bt-qatc-form-variant-input[data-only-child]')) {
                console.log('hit !!!')
                  const input = quickCartContainer.querySelector('.bt-qatc-form-variant-input[data-only-child]')
                  fetch(`${routes.cart_url}.json`)
                  .then( response => response.json())
                  .then( cartData => {
                    const cart = cartData;
                    const totalCartPrice = cart.total_price / 100;
                    const selectedPrice = parseFloat(input.dataset.price) /100;
                    const variantQuantity = 1;
                    const projectedTotalPrice = totalCartPrice + selectedPrice * variantQuantity;
                    const itemInCart = cart.items.find((item) => item.variant_id === parseFloat(input.value));
    
                    if (projectedTotalPrice > 500) {
                      window.showAlert('You cannot exceed the maximum shopping limit of 500 USD');
                      return;
                    }
    
                    if (itemInCart && itemInCart.quantity >= 3) {
                      window.showAlert('Limit reached: Max 3 items per size can be added');
                      return;
                    }
    
                    atcFormApi(atcForm);
                    atcForm.reset();
                  })
                  .catch(error => {
                    console.error('Error fetching cart data:', error);
                  });
                } else {
                  quickCartContainer.querySelector('.bt-qatc-container').classList.add('is-visible');
                  quickCartContainer.querySelector('.bt-qatc-form-container').classList.add('is-visible');

                  const imageSources = mediaContainer.dataset.images.split(',');
                  if (mediaContainer && window.innerWidth < 769) {
                    imageSources.forEach( src => {
                      if (src) {
                        const img = document.createElement('img');
                        img.src = src;
                        img.alt = 'Ethnc Product';
                        mediaContainer.appendChild(img);
                      }
                    });
                  }
                  atcForm.addEventListener('input', (e) => {
                  e.preventDefault();
                  const input = e.target
                  fetch(`${routes.cart_url}.json`)
                  .then( response => response.json())
                  .then( cartData => {
                    const cart = cartData;
                    const totalCartPrice = cart.total_price / 100;
                    const selectedPrice = parseFloat(input.dataset.price) /100;
                    const variantQuantity = 1;
                    const projectedTotalPrice = totalCartPrice + selectedPrice * variantQuantity;
                    const itemInCart = cart.items.find((item) => item.variant_id === parseFloat(input.value));
    
                    if (projectedTotalPrice > 500) {
                      window.showAlert('You cannot exceed the maximum shopping limit of 500 USD');
                      return;
                    }
    
                    if (itemInCart && itemInCart.quantity >= 3) {
                      window.showAlert('Limit reached: Max 3 items per size can be added');
                      return;
                    }
    
                    atcFormApi(atcForm);
                    atcForm.reset();
                    mediaContainer.innerHtml = null;
                    quickCartContainer.querySelector('.bt-qatc-container').classList.remove('is-visible');
                    quickCartContainer.querySelector('.bt-qatc-form-container').classList.remove('is-visible');
                  })
                  .catch(error => {
                    console.error('Error fetching cart data:', error);
                  });
                });
              }
    
              if (quickCartContainer.querySelector('.ethnc-qatc-form-size-chart')) {
                quickCartContainer.querySelector('.ethnc-qatc-form-size-chart').addEventListener('click', evt => {
                  console.log('evt', evt.target.dataset.scList)
                  _sizeguide(evt.target.dataset.scList);
                  _openDrawer('scMeasure');
                  if (window.innerWidth < 749) {
                    quickCartContainer.querySelector('.bt-qatc-container').classList.remove('is-visible');
                    quickCartContainer.querySelector('.bt-qatc-form-container').classList.remove ('is-visible');
                  }
                });
              }
            });
          }
        });
      }
    
      async function atcFormApi(form) {
        try {
          const cartSections = document.querySelector('cart-notification, cart-drawer');
          const formData = new FormData(form);
          if (cartSections) {
            formData.append('sections', Array.from(cartSections.getSectionsToRender(), section => section.id));
          }
    
          formData.append('sections_url', window.location.pathname)
          const resp = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          });
    
          if (!resp.ok) {
            throw new Error("Error While adding to cart")
          }
    
          const data = await resp.json();
    
          if (cartSections) {
            cartSections.renderContents(data);
          }
        } catch (error) {
          console.log("Quick add to cart error!!!", error)
        }
      }
    
      const _variantListClose = () => {
        if (window.innerWidth > 768) {
          gridWrapper.querySelectorAll('.grid__item').forEach( productCard => {
            productCard.addEventListener('mouseleave', () => {
              if (productCard.querySelector('.bt-qatc-form-container')) {
                productCard.querySelector('.bt-qatc-form-container').classList.remove('is-visible');
              }
            });
          });
        }
      }
    
      const _cardSlider = () => {
        var gridItems = gridWrapper.querySelectorAll('.grid__item');
        gridItems.forEach( item => {
          var swiper = new Swiper(item.querySelector('.card_carousel'), {
            loop: true
          });
        });
      }
    
      _cardSlider();
      _cardAtcBtn();
      _variantListClose();
      BackProduct();
    
      function _sizeguide(url) {
        var sizeChart_url = `https://sizechart-revamp-be.alche.cloud/ajax_call_sizechart?shop=ethnic-gbp-uk.myshopify.com&tags=${url}`
        fetch(sizeChart_url).then(response => response.json()).then( datamain => {
          console.log(' datamain', datamain)
          let newdatamain = [];
          if(datamain.size_chart){
            newdatamain.push(datamain)
          }else{
            newdatamain = datamain.map(data => data)
          }
          datamain = newdatamain;
          var new_html = `<div class="new-size-chart-main">
             <div class="new-size-chart-heading">
                <h3>ITEM MEASUREMENTS</h3>
              </div>
            <div class="new-size-chart-titles">
          `
          datamain.forEach( (chart,index)=> {
            new_html += `<div class="new-size-chart-single-title ${index==0 && 'active'}" id="chart_${chart.size_chart.id}"> ${chart.size_chart.title}</div>`
          });
          new_html += '</div>'
    
          datamain.forEach( (chart,index)=> {
            new_html += `<div class="new-size-chart-single-data ${index==0 && 'active'}" data-id="chart_${chart.size_chart.id}"> 
              <div class="size-chart-img">
                <img src="${chart.size_chart.bottom_description}" loading="lazy"/>
              </div>
            <div class="new-size-chart-single-measure-headings">
                <div class="measure-unit measure-cm active">CM</div>
                <div class="measure-unit measure-inch">IN</div> 
              </div>
            `
            new_html += `<table class="size-table-contents">
              <thead>
                <tr class="size-chart-header">
            `
            chart.size_chart.grid_sizechart.forEach( (sizeoptions,index) =>{
              if(index == 0) {
                sizeoptions.forEach((option,innerindex)=>{
                  new_html += `<th class="size-chart-header-th"> <span class="${innerindex == 0 && 'border-right'}">${option}</span></th>`
                })
              }
            })
    
            new_html += `</tr>
              </thead>
            `
    
            new_html += `<tbody>`
            chart.size_chart.grid_sizechart.forEach( (sizeoptions,index) =>{
              if (index != 0) {
                new_html += `<tr class="size-chart-row">`
                sizeoptions.forEach((option,innerindex)=>{
                  new_html += `<td class="table-cell"><span class="${innerindex == 0 ? 'border-right' :'border-right unit row_inch'}">${option}</span> <span class="${innerindex == 0 ? 'border-right' :'border-right unit row_cm'}">${ innerindex == 0 ? option : (option * 2.54).toFixed(1)}</span></td>`
                });
                new_html += `</tr>` 
              }
            });
            new_html += `</tbody>`
            new_html += `</table></div>`
          })
          new_html += '</div>'
    
          document.querySelector(`#size-chart-main-collection`).innerHTML = new_html
    
          document.querySelectorAll('.measure-unit').forEach( measure_unit => {
            measure_unit.addEventListener('click',function(){
              var main_size_chart = measure_unit.closest('.new-size-chart-main')
              main_size_chart.querySelectorAll('.measure-unit').forEach( measure_unit_size => {
                measure_unit_size.classList.toggle('active');
              });
              if (measure_unit.classList.contains('measure-cm')){
                main_size_chart.querySelectorAll('.size-chart-row span.unit').forEach( row => {
                  if (row.classList.contains('row_cm')) {
                    row.setAttribute('style','display:block');
                  } else {
                    row.setAttribute('style','display:none');
                  }
                });
              } else {
                main_size_chart.querySelectorAll('.size-chart-row span.unit').forEach(row=>{
                  if (row.classList.contains('row_inch')){
                    row.setAttribute('style','display:block')
                  } else {
                    row.setAttribute('style','display:none')
                  }
                })
              }
            });
          });
    
          document.querySelectorAll('.new-size-chart-single-title').forEach( mainsizecharttitle => {
            mainsizecharttitle.addEventListener('click',function(){
              var id = mainsizecharttitle.getAttribute('id')
              document.querySelectorAll('.new-size-chart-single-title').forEach( clasrem => clasrem.classList.remove('active'))
              document.querySelectorAll('.new-size-chart-single-data').forEach(single=> single.classList.remove('active'))
              mainsizecharttitle.classList.add('active')
              document.querySelector(`.new-size-chart-single-data[data-id="${id}"]`).classList.add('active')
            })
          });
        }).catch(error => {
          console.log("Error: ", error)
        });
      }
    
      function _sizeChartTab(evt, cityName,id) {
        var tablinks = document.querySelectorAll(".tablinks"),
        tabcontent = document.querySelectorAll(".tabcontent");
        tablinks.forEach( (tablink, tabid) => {
          tablink.addEventListener("click", function() {
            var dataIDClicked = tablink.getAttribute('data-id')
            document.querySelectorAll(`.size-chart-content-wrapper_${dataIDClicked} .tablinks`).forEach( hideTabLinks => hideTabLinks.classList.remove('active'))
            document.querySelectorAll(`.size-chart-content-wrapper_${dataIDClicked} .tabcontent`).forEach( hideTabContent => hideTabContent.classList.remove('active'))
            tablink.classList.add('active')
            document.querySelector(`.size-chart-content-wrapper_${dataIDClicked} .tabcontent[data-elem="${tablink.getAttribute('data-elem')}"]`).classList.add('active')
          });
        });
      };
    
      function _openDrawer(id){
        console.log('id',id)
        document.body.style.overflow ='hidden'
        var drawer = document.querySelector(`#${id}`)
        console.log('drawer',drawer)
        document.querySelector('.new-blur-overlay').classList.toggle('active');
        drawer.classList.add('active')
      }
      function _closeDrawer() {
        document.body.style.overflow ='auto'
        document.querySelector('.new-blur-overlay').classList.remove('active');
        document.querySelectorAll('.new-drawer').forEach(drawer => drawer.classList.remove('active'))
      }
      document.querySelector('.new-blur-overlay').addEventListener('click',()=>{ closeDrawer() })
      document.querySelectorAll('.new-drawer .closeDrawer').forEach( closeD => closeD.addEventListener('click',()=>{ closeDrawer() }))
      _closeDrawer()

      if (typeof Ajaxinate !== 'undefined' && gridWrapper) {
        const endlessScroll = new Ajaxinate({
          container: '#product-grid',
          pagination: '#AjaxinatePagination',
          loadingText: 'Loading...',
          method: "scroll",
          offset: 1000,
          callback: function() {
            _cardSlider()
            _cardAtcBtn()
            _variantListClose()
          }
        });
      }
  }

  static priceFilter() {
    (function() {
      const parent = document.querySelector('.range-slider');
      console.log(parent,"parent")
      if (!parent) {
        return;
      }
      const rangeS = parent.querySelectorAll('input[type="range"]'),
      numberS = parent.querySelectorAll('input[type="number"]');
      console.log(rangeS)
      rangeS.forEach((el) => {
        el.oninput = () => {
          var slide1 = parseFloat(rangeS[0].value),
              slide2 = parseFloat(rangeS[1].value);

          if (slide1 > slide2) {
            [slide1, slide2] = [slide2, slide1];
          }

          numberS[0].value = slide1;
          numberS[1].value = slide2;
        }
      });

      numberS.forEach((el) => {
        el.oninput = () => {
          var number1 = parseFloat(numberS[0].value),
              number2 = parseFloat(numberS[1].value);

          if (number1 > number2) {
            var tmp = number1;
            numberS[0].value = number2;
            numberS[1].value = tmp;
          }

          rangeS[0].value = number1;
          rangeS[1].value = number2;
        }
      });
    })();
  }

  static autoCloseTab() {
    const detailsList = document.querySelectorAll(".mobile-facets__main details");

    function handleDetailToggle(event) {
      if (!event.target.open) return;
      for (var details of detailsList) {
        details.open = details === event.target;
      }
    }

    for (let details of detailsList) {
      details.addEventListener("toggle", handleDetailToggle);
    }

    document.querySelectorAll('.mobile-facets__main-list-item').forEach( filterTab => {
      filterTab.addEventListener('click', () =>{
        if (document.querySelector('.mobile-facets__main-list-item.active')) {
          document.querySelector('.mobile-facets__main-list-item.active').classList.remove('active');
        }
  
        filterTab.classList.add('active');
        document.querySelector(`.mobile-facets__details.js-filter[data-index="mobile-${filterTab.dataset.filterIndex}"]`).classList.add('menu-opening');
        document.querySelector(`.mobile-facets__details.js-filter[data-index="mobile-${filterTab.dataset.filterIndex}"]`).setAttribute('open',true);
      });
    });
  }

  // static renderProductCount(html) {
  //   const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
  //   const container = document.getElementById('ProductCount');
  //   const containerDesktop = document.getElementById('ProductCountDesktop');
  //   container.innerHTML = count;
  //   container.classList.remove('loading');
  //   if (containerDesktop) {
  //     containerDesktop.innerHTML = count;
  //     containerDesktop.classList.remove('loading');
  //   }
  //   const loadingSpinners = document.querySelectorAll(
  //     '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
  //   );
  //   loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  // }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', ()=>{
        this.onRangeChange.bind(this)
      }));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));
    console.log(input);
    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

(function() {
  const parent = document.querySelector('.range-slider');
  console.log(parent,"parent")
  if (!parent) {
    return;
  }
  const rangeS = parent.querySelectorAll('input[type="range"]'),
  numberS = parent.querySelectorAll('input[type="number"]');
  console.log(rangeS)
  rangeS.forEach((el) => {
    el.oninput = () => {
      var slide1 = parseFloat(rangeS[0].value),
          slide2 = parseFloat(rangeS[1].value);

      if (slide1 > slide2) {
        [slide1, slide2] = [slide2, slide1];
      }

      numberS[0].value = slide1;
      numberS[1].value = slide2;
    }
  });

  numberS.forEach((el) => {
    el.oninput = () => {
      var number1 = parseFloat(numberS[0].value),
          number2 = parseFloat(numberS[1].value);

      if (number1 > number2) {
        var tmp = number1;
        numberS[0].value = number2;
        numberS[1].value = tmp;
      }

      rangeS[0].value = number1;
      rangeS[1].value = number2;
    }
  });
})();